<ng-content select="elm-progress-spinner-track"></ng-content>

<mat-progress-spinner
  [value]="percentage"
  [color]="color"
  [mode]="mode"
  [diameter]="[diameter]"
  [strokeWidth]="strokeWidth"
>
</mat-progress-spinner>

<div class="progress-content">
  <div><ng-content></ng-content></div>
</div>
